import Model, { valueWithArray } from 'ducker-model';

// 1.定义property
const property = {
  FHINFO: valueWithArray(Object),
  FCINFO: valueWithArray(Object),
};

// 2.定义replacedKeyFromPropertyName
const replacedKeyFromPropertyName = {
  FHINFO: {
    property: 'FHINFO',
    defaultValue: [],
  },
  FCINFO: {
    property: 'FCINFO',
    defaultValue: [],
  },
};
export default new Model(property, replacedKeyFromPropertyName);
